
import { AgeTagType } from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import router from "@/router";

const SurveyModule = namespace("survey");

@Options({
  components: {},
  beforeRouteEnter: (to, from, next) => {
    if (
      from.fullPath !== "/survey/entrance" &&
      from.fullPath !== "/survey/how-old-age" &&
      from.fullPath !== "/survey/which-layout"
    ) {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
})
export default class SurveyHowOldByAge extends Vue {
  @SurveyModule.Action("updatePageStateByAgeTag")
  public updatePageStateByAgeTag!: (tag: AgeTagType) => Promise<void>;

  @SurveyModule.Action("updateSurveyAge")
  private updateSurveyAge!: (age: number) => Promise<void>;

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  public isVisible = false;
  public isFadeOut = false;

  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  public async mounted() {
    await this.updateIsWhiteout(false);
    window.scrollTo({ top: 0 });
    this.isFadeOut = false;
    this.isVisible = true;
  }

  public async nextPage(tag: AgeTagType) {
    await this.updatePageStateByAgeTag(tag);

    if (tag === "100_AND_OVER") {
      await this.updateIsWhiteout(true);
      await this.updateSurveyAge(100);
      this.$router.push("/survey/which-layout");
    } else {
      this.isFadeOut = true;
      this.$router.push("/survey/how-old-age");
    }
  }

  private byAgeWordList: Array<{ tag: AgeTagType; word: string }> = [
    {
      tag: "UNDER_10",
      word: "0〜9さい",
    },
    {
      tag: "10S",
      word: "10〜19才",
    },
    {
      tag: "20S",
      word: "20〜29歳",
    },
    {
      tag: "30S",
      word: "30〜39歳",
    },
    {
      tag: "40S",
      word: "40〜49歳",
    },
    {
      tag: "50S",
      word: "50〜59歳",
    },
    {
      tag: "60S",
      word: "60〜69歳",
    },
    {
      tag: "70S",
      word: "70〜79歳",
    },
    {
      tag: "80S",
      word: "80〜89歳",
    },
    {
      tag: "90S",
      word: "90〜99歳",
    },
    {
      tag: "100_AND_OVER",
      word: "100歳以上",
    },
  ];

  private get subtitleWord() {
    let word = "";
    return word;
  }
}
